import React, {Component} from 'react';
import { Link, withRouter } from 'react-router-dom';

class Banner extends Component {
	constructor(props){
		super(props);
		this.state = {
			search: this.props.match.params.search ? this.props.match.params.search : ``
		}
	}

	handleChange(e) {

		const target = e.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		},()=>console.log(this.state.search))
	}

	handleSubmit(e){
		e.preventDefault();

		let s = this.state.search ? this.state.search : "All Contracts";

		console.log("Looking: ",s);

		this.props.history.push("/search/"+s.replace(/\s+/g, '-').toLowerCase());

	}

	render() {
		return (
			<div className="banner container-fluid text-center">
				<div className="p-0 container">
					<h1>Create and customize fast and easy contracts.</h1>
					
					{/* Banner form */}
					<form className="header-form form-inline mt-5 mb-3 mx-auto" onSubmit={this.handleSubmit.bind(this)}>
						<div className="input-group mx-auto">
							<input className="form-control form-control-lg" name="search" type="search" placeholder="Search" aria-label="Search" onChange={this.handleChange.bind(this)} />
							<span className="input-group-btn">
								<button className="btn my-2 my-sm-0 default h-100" type="submit"><i className="fa fa-search" aria-hidden="true"></i></button>
							</span>
						</div>
					</form>

					<h2>...or click <Link to="/contracts">HERE</Link> to browse popular legal documents and forms.</h2>

				</div>
			</div>
		)
	}
}

export default withRouter(Banner);


// WEBPACK FOOTER //
// ./src/view/Banner.js